import ApptSel from 'src/components/ApptSel/ApptSel';
import { connect } from 'react-redux';
import { FrameworkActionCreator, VehiclesActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    customerInfo: state.Customer.Customer,
    specInfo: state.Specs.specs,
    viewApptList: state.Appointment.ViewApptList,
    selectedVehicle: state.Vehicles.selectedVehicle,
    vehicles: state.Vehicles.vehicles,
    locale: state.Framework.locale,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    theme: state.Framework.theme,
    identityVerified: state.Customer.identityVerified,
});

const mapDispatchToProps = {
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    setCustMode: FrameworkActionCreator.acSetCustMode,
    setVehNextAppt: VehiclesActionCreator.SetVehNextAppt,
    addLogEntry: FrameworkActionCreator.addLogEntry,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ApptSel);